import { ReaderIcon } from '@radix-ui/react-icons';
import { HTMLAttributes, type JSX } from 'react';

import { cn } from '../../utils/cn';

interface DocumentFileProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  icon?: JSX.Element;
}

export function DocumentFile({ className, icon = <ReaderIcon /> }: DocumentFileProps) {
  return (
    <div className={cn('flex items-center justify-center text-muted-foreground', className)}>
      {icon}
    </div>
  );
}
